/**
 * Reads the `code` off a Firebase auth rejection.
 *
 * Matches structurally instead of testing `instanceof FirebaseError`: an error
 * that crossed a bundle boundary keeps its `code` but loses its prototype, so
 * the `instanceof` check would silently stop recognising it.
 *
 * Optional-chaining the cast rather than `'code' in error` is deliberate — `in`
 * throws a TypeError on a primitive rejection (`Promise.reject('boom')`), which
 * would turn a handled error path into an unhandled one.
 *
 * @param error anything a rejected Firebase call can hand back
 * @returns the auth error code, or `undefined` for anything that is not a coded
 *   Firebase error (null, a primitive, a plain `Error`, a non-string `code`)
 */
export function firebaseErrorCode(error: unknown): string | undefined {
  const code = (error as { code?: unknown } | null | undefined)?.code
  return typeof code === 'string' ? code : undefined
}
